import { OutageState } from "src/types";

export const DEFAULT_INPUT_WIDTH = "18rem";

export const OUTAGE_STATE_TEXT: Record<OutageState, string> = {
    [OutageState.Open]: "outage.open",
    [OutageState.Finished]: "outage.finished",
    [OutageState.Cancelled]: "outage.cancelled",
};
